import useSWRImmutable from "swr/immutable";
import { useMemo } from "react";

import { baseApiUrl } from "../constants";
import { fetchLocations } from "../utils";

/**
 * Fetches the list of frequent postal locations for a given country code from the Postal Location API.
 * Returned `data` is a list of locations formatted for `DhlDropdown` component.
 *
 * @param {{countryCode: string|null}} props
 * @returns {{data: Awaited<ReturnType<typeof fetchLocations>>, error: any, loading: boolean}}
 */
export const useFrequentPostalLocations = ({ countryCode }) => {
  const apiUrl = new URL(baseApiUrl, window.location.origin);

  if (countryCode) {
    apiUrl.searchParams.set("countryCode", countryCode);
  }

  const { data = [], error, isLoading, isValidating } = useSWRImmutable(
    countryCode ? apiUrl.toString() : null, // Do not fetch if the country code is not provided
    (url) => fetchLocations({ url, onlyFrequent: true })
  );

  return useMemo(() => ({ data, error, loading: isLoading || isValidating }), [
    data,
    error,
    isLoading,
    isValidating,
  ]);
};
